<div class="st-rundown-full-screen-container">
    <div class="st-rundown-full-screen-header">
        <div class="st-rundown-full-screen-header-first-row">
            <mat-chip class="st-rundown-full-screen__type-rundown">{{ languageSettings?.PSTObjectTypeRundown }}</mat-chip>
            @if (rundownArchived()) {
                <mat-chip class="st-rundown-full-screen__type-archived">{{ languageSettings?.PSTRundownArchived }}</mat-chip>
            }
        </div>
        <div class="st-rundown-full-screen-header-second-row">
            <st-text-area-overlay
                #title
                required
                minRows="1"
                minHeight="1rem"
                class="st-rundown-full-screen__title"
                panelclass="st-rundown-full-screen__title"
                maxLength="50"
                disableNewLine
                maxOverlayRows="1"
                [value]="titleValue()"
                [disabled]="rundownDisabled() || rundownArchived()"
                [label]="webSlugPlaceholder()"
                [placeholder]="webSlugPlaceholder()"
                (changed)="updateRundown($event, PSTFieldNames.Title)" />
            <st-date-time-picker
                class="st-rundown-full-screen__start-time"
                asCustomField
                disabled
                [label]="startTimeLabel()"
                [value]="modTimeValue()"
                (timezoneChange)="timezoneChanged(PSTFieldNames.TargetPublicationDate, $event)"
                (changed)="updateRundown($event, PSTFieldNames.PSTRundownStartTime)" />

            <st-external-actions-overlay
                class="st-rundown-full-screen__external"
                inFullScreen
                [editable]="!rundownDisabled()"
                [disabled]="rundownDisabled()"
                [data]="data()" />
        </div>
    </div>

    <div
        class="st-rundown-full-screen-main-content"
        [dir]="isRtl()">
        <div class="st-rundown-full-screen-grid-menu-container">
            @for (item of items(); track $index) {
                @if (item.isDirectAction) {
                    <button
                        mat-button
                        class="st-story-item-full-screen-header__editor-options__option"
                        [disabled]="item.disabled"
                        (click)="onActionHandler(item)">
                        {{ item.label }}
                    </button>
                } @else {
                    <button
                        mat-button
                        class="st-story-item-full-screen-header__editor-options__option"
                        [disabled]="item.disabled"
                        [matMenuTriggerFor]="menu.baseMenu()"
                        (menuClosed)="onMenuClosed(item.id)">
                        {{ item.label }}
                    </button>
                    <st-toolbar-menu
                        #menu
                        [items]="item.options"
                        (action)="onActionHandler($event)" />
                }
            }
        </div>
        @if (isTemplate()) {
            <div class="st-rundown-full-screen__banner">
                <mat-icon>report</mat-icon>
                <div>{{ languageSettings?.PSTWebEditRundownTemplate }}</div>
            </div>
        }
        <div class="st-rundown-full-screen-rundown-actions">
            <button
                mat-icon-button
                class="st-rundown-full-screen__search-button"
                [matTooltip]="languageSettings?.PSTRundownMenuProductionSearchMenuOptions"
                [disabled]="rundownDisabled()"
                (click)="searchMenus()">
                <mat-icon fontSet="material-symbols-outlined">search</mat-icon>
            </button>
            <button
                mat-icon-button
                class="st-rundown-full-screen__rundown-properties-button"
                [matTooltip]="languageSettings?.PSTRundownMenuProductionRundownProperties"
                [disabled]="rundownDisabled()"
                (click)="showRundownProperties()">
                <mat-icon fontSet="material-symbols-outlined">settings</mat-icon>
            </button>
            <mat-divider vertical />
            <button
                mat-icon-button
                class="st-rundown-full-screen__add-row-above-button"
                [matTooltip]="languageSettings?.PSTRundownMenuProductionAddRowAbove"
                [disabled]="insertRowDisabled()"
                (click)="addRow(NewRowPositionEnum.UP)">
                <mat-icon fontSet="st-icons">mat-icon-insert-row-above</mat-icon>
            </button>
            <button
                mat-icon-button
                class="st-rundown-full-screen__add-row-below-button"
                [matTooltip]="languageSettings?.PSTRundownMenuProductionAddRowBelow"
                [disabled]="insertRowDisabled()"
                (click)="addRow(NewRowPositionEnum.DOWN)">
                <mat-icon fontSet="st-icons">mat-icon-insert-row-below</mat-icon>
            </button>
            <!-- <button
                mat-icon-button
                matTooltip="Insert Break"
                class="st-rundown-full-screen__insert-break-button"
                (click)="insertBreak()">
                <mat-icon fontSet="material-symbols-outlined">insert_page_break</mat-icon>
            </button> -->
            <mat-divider vertical />

            <button
                mat-icon-button
                class="st-rundown-full-screen__freeze-page-numbers-button"
                [matTooltip]="languageSettings?.PSTRundownMenuProductionFreezePageNumbers"
                [class.st-rundown-full-screen__freeze-page-numbers-button--active]="data()?.FreezePages"
                [disabled]="isRundownOptionDisabled() || rundownArchived()"
                (click)="freezePageNumbers()">
                <mat-icon fontSet="st-icons">mat-icon-freeze-page-numbers</mat-icon>
            </button>

            <button
                mat-icon-button
                class="st-rundown-full-screen__put-on-air-button"
                [matTooltip]="languageSettings?.PSTRundownMenuProductionPutOnAir"
                [class.st-rundown-full-screen__put-on-air-button--active]="data()?.OnAir"
                [disabled]="isRundownOptionDisabled() || rundownArchived()"
                (click)="onAir()">
                <mat-icon fontSet="st-icons">{{ onAirIcon() }}</mat-icon>
            </button>
            <mat-divider vertical />
            <!-- <button
                mat-button
                class="st-rundown-full-screen__recording-live-button"
                [matTooltip]="languageSettings?.PSTRundownMenuProductionRecordingLive"
                [class.st-rundown-full-screen__recording-live-button--active]="data().LTTRecording"
                [disabled]="rundownDisabled()"
                (click)="liveRecording()">
                @if (data().LTTRecording) {
                    <mat-icon>circle</mat-icon>
                } @else {
                    <mat-icon fontSet="material-symbols-outlined">circle</mat-icon>
                }
                REC
            </button>
            <mat-divider vertical /> -->

            <button
                mat-icon-button
                class="st-rundown-full-screen__lock-rundown-button"
                [matTooltip]="languageSettings?.PSTRundownMenuProductionLockRundown"
                [class.st-rundown-full-screen__lock-rundown-button--active]="data()?.Locked"
                [disabled]="isRundownOptionDisabled() || rundownArchived()"
                (click)="lockRundown()">
                <mat-icon fontSet="st-icons">{{ lockRundownIcon() }}</mat-icon>
            </button>
            <button
                mat-icon-button
                class="st-rundown-full-screen__lock-all-stories-button"
                [class.st-rundown-full-screen__lock-all-stories-button--active]="storiesLockStatus()"
                [matTooltip]="languageSettings?.PSTRundownMenuProductionLockAllStories"
                [disabled]="isRundownOptionDisabled() || rundownArchived()"
                (click)="lockAllStories()">
                <mat-icon fontSet="st-icons">{{ lockAllStoriesIcon() }}</mat-icon>
            </button>
            <button
                mat-icon-button
                class="st-rundown-full-screen__lock-timing-bar-button"
                [matTooltip]="languageSettings?.PSTRundownMenuProductionLockTimingBar"
                [class.st-rundown-full-screen__lock-timing-bar-button--active]="data()?.TimingLocked"
                [disabled]="isRundownOptionDisabled() || rundownArchived()"
                (click)="toggleLockingTimingBar()">
                <mat-icon fontSet="st-icons">{{ lockTimingBarIcon() }}</mat-icon>
            </button>
            <mat-divider vertical />
            <button
                mat-icon-button
                class="st-rundown-full-screen__mos-control-active-button"
                [matTooltip]="languageSettings?.PSTRundownMenuProductionMOSControlActive"
                [class.st-rundown-full-screen__mos-control-active-button--active]="data()?.MOSControl"
                [disabled]="isRundownOptionDisabled() || rundownArchived()"
                (click)="mosControlActive()">
                <mat-icon fontSet="st-icons">{{ mosControlIcon() }}</mat-icon>
            </button>
            <button
                mat-icon-button
                class="st-rundown-full-screen__mos-ready-to-air-button"
                [matTooltip]="languageSettings?.PSTRundownMenuProductionMOSReadyToAir"
                [class.st-rundown-full-screen__mos-ready-to-air-button--active]="data()?.MOSAir"
                [disabled]="isRundownOptionDisabled() || rundownArchived()"
                (click)="mosReadyToAir()">
                <mat-icon fontSet="st-icons">{{ mosReadyToAirIcon() }}</mat-icon>
            </button>
            <button
                mat-icon-button
                [matTooltip]="languageSettings?.PSTRundownMenuProductionMOSStorySend"
                [disabled]="isRundownOptionDisabled() || rundownArchived()"
                (click)="mosStorySend()">
                <mat-icon fontSet="st-icons">mat-icon-mos-story-send</mat-icon>
            </button>
        </div>
        <st-ro-grid
            #grid
            [itemsSource]="stories()"
            [gridLayout]="roLayout()"
            [record]="rundown()"
            [currentId]="currentId()"
            [isReadOnly]="isReadOnly()"
            [isSearchActive]="isSearchActive()"
            [selectAtPosition]="selectAtPosition()"
            [storiesLockStatus]="storiesLockStatus()"
            [isRundownDisabled]="rundownDisabled()"
            [isRundownArchived]="rundownArchived()"
            (toggleSearch)="isSearchActive.set(!isSearchActive())"
            (collectionChanged)="collectionChanged($event)"
            (collectionReordered)="collectionReordered($event)"
            (addStoryToRundown)="addStoryToRundown($event)"
            (selectedRowsChange)="selectedRowsChanged($event)"
            (openStoryContent)="openStory($event)"
            (deleteStory)="deleteStory($event)"
            (addRowOnCommand)="addRowOnCommand()"
            (selectAtPositionChange)="selectAtPosition.set($event)"
            (addRowAbove)="addRow(NewRowPositionEnum.UP)"
            (dropedScriptsToCollection)="moveScriptsToCollection($event)"
            (resizedColumn)="resizedColumn($event)" />
    </div>
</div>
